/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_CreatingInputs */

const en_settings_tickets_creating = /** @type {(inputs: Settings_Tickets_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting...`)
};

/**
* | output |
* | --- |
* | "Submitting..." |
*
* @param {Settings_Tickets_CreatingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_creating = /** @type {((inputs?: Settings_Tickets_CreatingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_CreatingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_creating(inputs)
});
export { settings_tickets_creating as "settings.tickets.creating" }